import { axios } from 'boot/axios'

export default {
  namespaced: true,
  state: {
    items: []
  },

  getters: {
    findIndex: ({ items }) => itemId => items.findIndex(({ id }) => id === itemId),
    find: ({ items }) => itemId => items.find(({ id }) => id === itemId),

    getInsurance: (state, { find, findIndex }) => insuranceId => findIndex(insuranceId) === -1 ? {} : find(insuranceId),
    getInsuranceLabel: (state, { getInsurance }) => insuranceId => getInsurance(insuranceId).name,

    insuranceOptions: ({ items }) => items.map(({ id, name }) => ({ label: name, value: id }))
  },

  actions: {
    fetchInsurances ({ commit, state: { items } }) {
      if (items.length === 0) {
        axios.get('insurances').then(({ data }) => { commit('SET_BANKS', data) })
      }
    }
  },

  mutations: {
    SET_BANKS (state, data) { state.items = data }
  }
}
